import notes from '@/release-notes/notes.json';

/**
 * The release notes a shipped request or idea can point at. The app opens the
 * matching What's new note from Your requests, so the id has to be one it ships.
 */
export interface ReleaseNoteOption {
  id: string;
  label: string;
}

type NoteEntry = { id: string; date: string; title: Record<string, string> };

export const RELEASE_NOTE_OPTIONS: ReleaseNoteOption[] = (notes as { entries: NoteEntry[] }).entries.map((n) => ({
  id: n.id,
  label: `${n.date} · ${n.title['en-US'] ?? n.id}`,
}));
